import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconMarking = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "icon/marking",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M17.4987 3.7487C16.5737 3.45703 15.557 3.33203 14.582 3.33203C12.957 3.33203 11.207 3.66536 9.9987 4.58203C8.79036 3.66536 7.04036 3.33203 5.41536 3.33203C3.79036 3.33203 2.04036 3.66536 0.832031 4.58203V16.7904C0.832031 16.9987 1.04036 17.207 1.2487 17.207C1.33203 17.207 1.3737 17.1654 1.45703 17.1654C2.58203 16.6237 4.20703 16.2487 5.41536 16.2487C7.04036 16.2487 8.79036 16.582 9.9987 17.4987C11.1237 16.7904 13.1654 16.2487 14.582 16.2487C15.957 16.2487 17.3737 16.4987 18.5404 17.1237C18.6237 17.1654 18.6654 17.1654 18.7487 17.1654C18.957 17.1654 19.1654 16.957 19.1654 16.7487V4.58203C18.6654 4.20703 18.1237 3.95703 17.4987 3.7487ZM17.4987 14.9987C16.582 14.707 15.582 14.582 14.582 14.582C13.1654 14.582 11.1237 15.1237 9.9987 15.832V6.2487C11.1237 5.54036 13.1654 4.9987 14.582 4.9987C15.582 4.9987 16.582 5.1237 17.4987 5.41536V14.9987Z",
				fill: "#5C5C5C"
			}),
			/* @__PURE__ */ _jsx("ellipse", {
				id: "Ellipse 1",
				cx: 15.8346,
				cy: 14.1667,
				rx: 4.16667,
				ry: 4.16667,
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Subtract",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M15.8346 18.3333C18.1358 18.3333 20.0013 16.4679 20.0013 14.1667C20.0013 11.8655 18.1358 10 15.8346 10C13.5334 10 11.668 11.8655 11.668 14.1667C11.668 16.4679 13.5334 18.3333 15.8346 18.3333ZM13.7324 13.8744L14.9255 15.0498L17.9369 12.0833L18.3346 12.4751L14.9255 15.8333L13.3346 14.2662L13.7324 13.8744Z",
				fill: "#5C5C5C"
			})
		]
	})
});
export default SvgIconMarking;
